export default "__VITE_ASSET__8be7da10__"